
import { Component, Prop, Vue } from "vue-property-decorator";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";
import { SMCases, SMUser } from "@/store";
import {
  APPROVED_BY_EXPERT_OA_STATUS,
  APPROVED_BY_HO_OA_STATUS,
  IN_PROGRESS_OA_STATUS,
  ON_REVIEW_OA_STATUS,
  READY_TO_SUBMIT_OA_STATUS,
  REJECTED_BY_HO_OA_STATUS,
  SERVICE_STEP_ALIASES,
} from "@/constants/services";
import { NOTIFICATION_PROPS } from "@/constants/notification";

@Component({
  components: {
    NotificationTemplate,
  },
})
export default class OnlineApplicationNotification extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isCosTab?: boolean;
  @Prop({ type: Boolean, default: false }) readonly isSkilledWorkerCase?: boolean;
  @Prop({ type: Boolean, default: false }) readonly isCosSwCase?: boolean;
  @Prop({ type: Boolean, default: false }) readonly isSponsorLicenceCase?: boolean;
  @Prop({ type: Boolean, default: false }) readonly isDependantCase?: boolean;

  stepAlias = SERVICE_STEP_ALIASES;

  get notificationProps() {
    return NOTIFICATION_PROPS;
  }

  get hasContent(): boolean {
    return !!this.$slots["default"];
  }

  get text() {
    if (this.isDependantCase) {
      switch (SMCases.onlineApplicationStatus) {
        case IN_PROGRESS_OA_STATUS:
        case READY_TO_SUBMIT_OA_STATUS:
          return this.$tc("dependant.inProgress");
        default:
          return SMUser.isEmployee ? this.$tc("employee") : null;
      }
    }

    if (this.isSkilledWorkerCase) {
      switch (SMCases.caseStepAlias) {
        case this.stepAlias.sw_step_data_submission:
        case this.stepAlias.sw_step_info:
          return this.$tc("skilled_worker.inProgress");
        case this.stepAlias.sw_step_expert_review:
          return this.$tc("skilled_worker.onReview");
        case this.stepAlias.sw_step_payment:
          return this.$tc("skilled_worker.payment");
        case this.stepAlias.sw_step_application_submission:
          return this.$tc("skilled_worker.submission");
        case this.stepAlias.sw_step_visa_decision:
          return SMCases.onlineApplicationStatus === APPROVED_BY_EXPERT_OA_STATUS
            ? this.$tc("skilled_worker.submitted")
            : this.$tc("skilled_worker.visaDecision");

        default:
          return null;
      }
    }

    if (this.isCosSwCase) {
      if (this.isCosTab) return this.$tc("cos");

      switch (SMCases.caseStepAlias) {
        case this.stepAlias.sw_step_data_submission:
        case this.stepAlias.sw_step_info:
        case this.stepAlias.cos_sw_inside_step_data_submission:
          return this.$tc("cos_sw.inProgress");
        case this.stepAlias.sw_step_expert_review:
          return this.$tc("cos_sw.onReview");
        case this.stepAlias.sw_step_payment:
          return this.$tc("cos_sw.payment");
        case this.stepAlias.sw_step_cos_creation:
          return this.$tc("cos_sw.cosCreation");
        case this.stepAlias.sw_step_application_submission:
          return this.$tc("cos_sw.submission");
        case this.stepAlias.sw_step_visa_decision:
          return SMCases.onlineApplicationStatus === APPROVED_BY_EXPERT_OA_STATUS
            ? this.$tc("skilled_worker.submitted")
            : this.$tc("cos_sw.visaDecision");

        default:
          return null;
      }
    }

    if (SMUser.isEmployee) return this.$tc("employee");

    if (this.isSponsorLicenceCase) {
      switch (SMCases.onlineApplicationStatus) {
        case ON_REVIEW_OA_STATUS:
          return this.$tc("sponsor_licence.onReview");
        case IN_PROGRESS_OA_STATUS:
        case READY_TO_SUBMIT_OA_STATUS:
          return this.$tc("sponsor_licence.inProgress");
        case APPROVED_BY_EXPERT_OA_STATUS:
        case APPROVED_BY_HO_OA_STATUS:
        case REJECTED_BY_HO_OA_STATUS:
          return this.$tc("sponsor_licence.approved");
        default:
          return null;
      }
    }

    return null;
  }
}
